<section>
	<vb-ui-form-group [ngClass]="styles.v2FormGroup" labelClass="labelClass" [parentNgModel]="control">

		<label [id]="labelId" #uiLabel>
			{{label}}
		</label>

		<div uiControl role="group" [ngClass]="styles.uploadContainer">
			<div class="btn-file" *ngIf="!processing; else spinner" [hidden]="!!value?.url" [ngClass]="[styles.uploadBtn, isAdminTheme ? 'admin' : styles.themedUploadBtn]" vbBtnPrimary fileUpload (onAdd)="setImageFile($event.file)">
				{{ 'Upload' | translate }}
				<span class="glyphicons disk_open"></span>
				<input type="file" [attr.aria-labelledby]="labelId" [disabled]="isFileDisabled">
			</div>
			<ng-template #spinner>
				<vb-ui-spinner [size]="'large'">

				</vb-ui-spinner>
			</ng-template>

			<div *ngIf="value?.url" [ngClass]="styles.imagePreview">
				<img [src]="value.url" [alt]="label" vbImageLoad/>
				<span *ngIf="!imageComponentMetadata.readOnly">
					<button type="button" *ngIf="imageComponentMetadata.showDeleteButton" (click)="clearSelectedImage()" vbBtnWhite>
						{{ 'Delete' | translate }}
					</button>
					<button type="button" *ngIf="imageComponentMetadata.showResetButton && value && !isDefaultImageSelected" (click)="setDefaultImage()" vbBtnWhite>
						{{ 'ResetDefault' | translate }}
					</button>
				</span>
			</div>
		</div>

		<div role="alert" uiValidation>
			<div *ngIf="control?.invalid" vbUiErrorMessage>

				@if (control.errors.required) {
					{{ 'ThisFieldIsRequired' | translate }}
				} @else if (control.errors.fileType) {
					{{ 'ImageSelector_FileExtensionError' | translate }}: jpg, gif, png
				} @else if (control.errors.size) {
					{{ 'ImageSelector_SizeError' | translate : { '0': imageComponentMetadata.maxSize | fileSize } }}
				}
			</div>
		</div>
	</vb-ui-form-group>
</section>
